(() => {
  const SELECTORS = {
    customizerFrame: '.rg-theme-frame',
    productForm: 'product-form form[data-type="add-to-cart-form"]',
  };
  const REQUEST_TIMEOUT_MS = 4000;
  const pendingRequests = new Map();

  const LEGACY_PROPERTY_NAMES = [
    'properties[LV8 Design ID]',
    'properties[LV8 Design Side]',
    'properties[LV8 Design Summary]',
    'properties[LV8 Design JSON]',
    'properties[LV8 Save Mode]',
  ];

  const PREVIEW_STORAGE_KEY = 'lv8PreviewImageByDesignId';


  function getCustomizerFrame() {
    return document.querySelector(SELECTORS.customizerFrame);
  }

  function getCustomizerOrigin(frame) {
    try {
      return new URL(frame?.src || '', window.location.href).origin;
    } catch (error) {
      return window.location.origin;
    }
  }

  function isTrustedCustomizerEvent(event) {
    const frame = getCustomizerFrame();
    if (!frame || !frame.contentWindow) return false;
    if (event.source !== frame.contentWindow) return false;

    const trustedOrigin = getCustomizerOrigin(frame);
    return !event.origin || event.origin === 'null' || event.origin === trustedOrigin;
  }

  function ensureHiddenInput(form, name, value = '') {
    let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
    return input;
  }

  function getProductForm() {
    return document.querySelector(SELECTORS.productForm);
  }

  function readStoredPreviews() {
    try {
      const raw = window.localStorage.getItem(PREVIEW_STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : {};
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function writeStoredPreviews(previews) {
    try {
      window.localStorage.setItem(PREVIEW_STORAGE_KEY, JSON.stringify(previews));
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function storePreviewImage(designId, previewDataUrl) {
    if (!designId || !previewDataUrl) return;
    const previews = readStoredPreviews();
    previews[designId] = previewDataUrl;
    writeStoredPreviews(previews);
  }

  function removeLegacyInputs(form) {
    if (!form) return;

    LEGACY_PROPERTY_NAMES.forEach((name) => {
      form.querySelectorAll(`input[name="${CSS.escape(name)}"]`).forEach((input) => input.remove());
    });
  }

  
  function removeInput(form, name) {
    const el = form.querySelector(`input[name="${CSS.escape(name)}"]`);
    if (el) el.remove();
  }

function updateProperties(payload) {
    const form = getProductForm();
    removeInput(form, 'properties[LV8 Preview Image]');
    removeInput(form, 'properties[_LV8 Preview Image]');
    if (!form || !payload) return;

    removeLegacyInputs(form);

    storePreviewImage(payload.designId || '', payload.previewDataUrl || '');

    const fields = {
      'properties[Design Side]': payload.view || '',
      'properties[Design Summary]': payload.summary || '',
      'properties[_LV8 Design ID]': payload.designId || '',
      'properties[_LV8 Design JSON]': payload.designJson || '',
      'properties[_LV8 Save Mode]': payload.mode || 'embedded-theme',
    };

    Object.entries(fields).forEach(([name, value]) => ensureHiddenInput(form, name, value));
    form.dataset.lv8CustomizerReady = 'true';
    form.dataset.lv8DesignId = payload.designId || '';
  }

  function requestSnapshot() {
    const frame = getCustomizerFrame();
    if (!frame || !frame.contentWindow) return Promise.resolve(false);

    const requestId = `lv8-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const targetOrigin = getCustomizerOrigin(frame);

    return new Promise((resolve) => {
      const timeoutId = window.setTimeout(() => {
        pendingRequests.delete(requestId);
        resolve(false);
      }, REQUEST_TIMEOUT_MS);

      pendingRequests.set(requestId, {
        resolve(value) {
          window.clearTimeout(timeoutId);
          resolve(value);
        },
      });

      frame.contentWindow.postMessage({ type: 'LV8_REQUEST_SNAPSHOT', requestId }, targetOrigin);
    });
  }

  function updateFrameHeight(nextHeight) {
    const frame = getCustomizerFrame();
    if (!frame) return;

    const parsedHeight = Number(nextHeight);
    if (!Number.isFinite(parsedHeight) || parsedHeight <= 0) return;

    const clampedHeight = Math.max(900, Math.min(3200, Math.round(parsedHeight)));
    frame.style.height = `${clampedHeight}px`;
  }

  window.addEventListener('message', (event) => {
    if (!isTrustedCustomizerEvent(event)) return;

    const data = event.data;
    if (!data || typeof data !== 'object') return;

    if (data.type === 'LV8_CUSTOMIZER_HEIGHT') {
      updateFrameHeight(data.height);
      return;
    }

    if (data.type !== 'LV8_CUSTOMIZER_SNAPSHOT') return;

    updateProperties(data.payload);

    const requestId = data.requestId;
    if (requestId && pendingRequests.has(requestId)) {
      pendingRequests.get(requestId).resolve(true);
      pendingRequests.delete(requestId);
    }
  });

  window.lv8CustomizerBridge = {
    async beforeAddToCart(form) {
      if (!form || form !== getProductForm()) return;
      removeLegacyInputs(form);
      await requestSnapshot();
      removeLegacyInputs(form);
    },
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(SELECTORS.productForm);
    if (!form) return;
    removeLegacyInputs(form);
  }, true);

  window.addEventListener('load', () => {
    if (getCustomizerFrame()) {
      requestSnapshot();
    }
  });
})();
